import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@/vue/store';
import qs from 'query-string';
import { mapGetters } from 'vuex';
export default {
  store: store,
  data: function data() {
    return {
      usedTea: {
        matcha: {
          label: '抹茶',
          url: '/shop/cat/1'
        },
        gyokuro: {
          label: '玉露',
          url: '/shop/cat/15'
        },
        kabusecha: {
          label: 'かぶせ茶',
          url: '/shop/cat/15'
        },
        sencha: {
          label: '煎茶',
          url: '/shop/cat/16'
        },
        genmaicha: {
          label: '玄米茶',
          url: '/shop/cat/17'
        },
        hojicha: {
          label: 'ほうじ茶',
          url: '/shop/cat/17'
        },
        coldSencha: {
          label: '冷煎茶',
          url: '/shop/cat/18'
        },
        karigane: {
          label: '雁ヶ音',
          url: '/shop/cat/40'
        },
        kawayanagi: {
          label: '川柳',
          url: '/shop/cat/40'
        },
        mecha: {
          label: '芽茶',
          url: '/shop/cat/40'
        },
        konacha: {
          label: '粉茶',
          url: '/shop/cat/40'
        },
        shincha: {
          label: '新茶',
          url: '/shop/cat/2'
        },
        // 新茶カテゴリは存在しないのでフラグ自体が間違ってる可能性あり
        oobukucha: {
          label: '大福茶',
          url: '/shop/cat/42'
        },
        tubokiricha: {
          label: '壷切茶',
          url: '/shop/cat/39'
        }
      }
    };
  },
  computed: _objectSpread({}, mapGetters('app', ['h']), {}, mapGetters('shopmenu-store', ['menuList']))
};